import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import { call } from "../../assets/img";
import { Table } from "../../Component/Table/Table";
import { edit_icon } from "../../assets/img";
import { ICON_FILTER, URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import useStoreKv from "../redux/store/useStorekv";
import CustomScroll from "../../Component/CustomScroll";
import SubmitButton from "../../Component/SubmitButton";
import { MaskIcon } from "../../Component/MaskIcon";
import { PRIMARY_COLOR, PRIMARY_COLOR_RGB } from "../../Services/Colors";

const ClientList = () => {
  const { kv, set } = useStoreKv();
  const ClientListData = kv.clientList || [];
  const REPORT_SCROLL_KEY = "reportScrollPosition";
  const CLIENT_LIST_PAGE_KEY = "clientListCurrentPage";
  const navigate = useNavigate();
  const location = useLocation();
  const scrollRef = useRef(null);
  const navigationType = useNavigationType();
  const lastRequestId = useRef(0);

  useEffect(() => {
    const savedPosition = sessionStorage.getItem(REPORT_SCROLL_KEY);
    if (scrollRef.current) {
      if (navigationType === "POP" && savedPosition) {
        setTimeout(() => { if (scrollRef.current) scrollRef.current.scrollTop = Number(savedPosition); }, 0);
      } else {
        setTimeout(() => {
          if (scrollRef.current) scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
          sessionStorage.setItem(REPORT_SCROLL_KEY, 0);
        }, 0);
      }
    }
  }, [location, navigationType]);

  useEffect(() => {
    const content = scrollRef.current;
    if (content) content.addEventListener("scroll", handleScroll);
    return () => { if (content) content.removeEventListener("scroll", handleScroll); };
  }, []);

  const handleScroll = () => {
    const position = scrollRef.current ? scrollRef.current.scrollTop : 0;
    sessionStorage.setItem(REPORT_SCROLL_KEY, position);
  };

  useEffect(() => {
    const handleBeforeUnload = () => sessionStorage.setItem("isReload", "true");
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(() => {
    const savedPage = Number(sessionStorage.getItem(CLIENT_LIST_PAGE_KEY));
    return Number.isInteger(savedPage) && savedPage > 0 ? savedPage : 1;
  });
  const [pagecount, setPagecount] = useState();
  const [totalUser, setTotalUser] = useState(0);
  const [totalUser1, setTotalUser1] = useState(0);
  const [loading, setLoading] = useState(false);
  const [browsHeader, setBrowsHeader] = useState(true);
  const [owners, setOwners] = useState(ClientListData);

  const getList = async (page = 1, search = "", currentRequestId) => {
    if (!kv.clientList || kv.clientList.length === 0) setLoading(true);
    try {
      // TODO: replace "search" with the actual param name the API team gives you
      const query = search ? `&search=${encodeURIComponent(search)}` : "";
      const res = await get(`${URLS.CLIENT}?page=${page}${query}`);
      if (currentRequestId !== lastRequestId.current) return;
      if (res?.status === "success") {
        setOwners(res?.data || []);
        set("clientList", res?.data || []);
        setTotalUser1(res?.overall_count);
        setTotalUser(res?.pagination?.total_count);
        setPagecount(res?.pagination?.total_pages);
      } else {
        setOwners([]);
        set("clientList", []);
        setTotalUser1(0);
        setTotalUser(0);
        setPagecount(0);
      }
    } catch (error) {
      if (currentRequestId !== lastRequestId.current) return;
      console.error("Error fetching client list:", error);
      setOwners([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    sessionStorage.setItem(CLIENT_LIST_PAGE_KEY, String(page || 1));
  }, [page]);

  useEffect(() => {
  const delayDebounce = setTimeout(() => {
    const currentRequestId = ++lastRequestId.current;
    getList(page, searchInput, currentRequestId);
  }, 500); // waits 500ms after typing stops

  return () => clearTimeout(delayDebounce);
}, [searchInput, page]);

  
  const handleClear = () => {
  setSearchInput("");
  setPage(1);
};


  const columns = React.useMemo(() => [
    {
      Header: () => <div style={{ textAlign: "center" }}>Client <br /> ID</div>,
      accessor: "id",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: " Name",
      accessor: "name",
      Cell: ({ value }) => {
        const truncated = value && value.length > 14 ? value.substring(0, 14) + "..." : value;
        return <p style={{ whiteSpace: "nowrap", width: "132px" }}>{truncated}</p>;
      },
    },
    {
      Header: " Mobile No",
      accessor: "mobile",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: <span>Wallet<br />balance</span>,
      accessor: "wallet_amount",
      Cell: ({ value }) => <p className="text-nowrap">{`₹ ${value}`}</p>,
    },
    {
      Header: <span>Client<br />Editor</span>,
      accessor: "Editor",
      Cell: ({ row }) => (
        <div className="d-flex ac-jc gap-3">
          <button
            onClick={() => navigate("/client-report", { state: { type: "edit", data: row.original } })}
            className="cust-btn"
          >
            <MaskIcon src={edit_icon} alt="" className="editor-btn" />
          </button>
        </div>
      ),
    },
  ], [page]);

  const maxHeight = useRef(window.visualViewport?.height || window.innerHeight);
  const isFirstRun = useRef(true);

  useEffect(() => {
    const handleResize = () => {
      const visibleHeight = window.visualViewport?.height || window.innerHeight;
      if (isFirstRun.current) { isFirstRun.current = false; setBrowsHeader(true); return; }
      if (visibleHeight < maxHeight.current) setBrowsHeader(true);
      else { maxHeight.current = visibleHeight; setBrowsHeader(false); }
    };
    window.visualViewport?.addEventListener("resize", handleResize);
    return () => window.visualViewport?.removeEventListener("resize", handleResize);
  }, [browsHeader]);

  return (
    <div className="dashRightView marginScroll">
      <CustomScroll ref={scrollRef}>
        <div style={{ paddingTop: 0 }} className="container_overalls">

          {/* ── Single search input ── */}
          <div className="form-group col-md-5 text-start my-3">
            <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">
              Search
            </label>
            <div
              className="login-input1 mt-1"
              style={{ display: "flex", alignItems: "center" }}
            >
              {/* <svg style={{ marginLeft: 12, flexShrink: 0 }} width="17" height="17" viewBox="0 0 20 20" fill="none">
                <circle cx="9" cy="9" r="6.5" stroke={PRIMARY_COLOR} strokeWidth="1.8" />
                <path d="M14 14l3.5 3.5" stroke={PRIMARY_COLOR} strokeWidth="1.8" strokeLinecap="round" />
              </svg> */}
              <input
                value={searchInput}
                onChange={(e) => {
                  setPage(1);
                  setSearchInput(e.target.value);
                }}
                type="text"
                placeholder="Search by name, mobile or client ID"
                className="placholdercolorchanges2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20"
                style={{ flex: 1, border: "none", outline: "none", background: "transparent", padding: "0 10px", height: 50 }}
              />
              {searchInput && (
                <button
                  onClick={handleClear}
                  style={{ background: "transparent", border: "none", cursor: "pointer", color: PRIMARY_COLOR, fontSize: 20, lineHeight: 1, padding: "0 12px", flexShrink: 0 }}
                  title="Clear"
                >
                  ×
                </button>
              )}
            </div>
          </div>

         

          {/* ── Total count (left) + Add Client button (right) ── */}
          <div
            className="col-md-5 my-3"
            style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
          >
            <p className="f3 fs-xs-15 fs-sm-13 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-19 mb-0">
              Total Users Count: {totalUser1}
            </p>

            <button
              onClick={() => navigate("/client-add", { state: { type: "add" } })}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                background: PRIMARY_COLOR,
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: "8px 16px",
                fontWeight: 700,
                fontSize: 13,
                cursor: "pointer",
                boxShadow: `0 2px 8px rgba(${PRIMARY_COLOR_RGB.join(",")},0.22)`,
                whiteSpace: "nowrap",
              }}
            >
              Add Client
            </button>
          </div>

          <Table
            columns={columns}
            setPageno={setPage}
            totalPages={totalUser}
            pagecount={pagecount}
            pageno={page}
            data={owners || []}
            loading={loading}
            show={false}
            serverSide={true}
          />
        </div>
      </CustomScroll>
    </div>
  );
};

export default ClientList;
